import {PlusIcon} from "@/theme/assets/icons";
import {Button} from "@/theme/ui";
import React from "react";

export const AddButton = ({...rest}) => {
    return (
        <>
            <Button
                icon={<PlusIcon />}
                type="primary"
                className={'button_icon'}
                style={{background: "#DB3333", color: 'white'}}
                {...rest}
            />
        </>
    );
}